import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-remove-from-cart-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './remove-from-cart-dialog.component.html',
  styleUrls: ['./remove-from-cart-dialog.component.css']
})
export class RemoveFromCartDialogComponent {
  constructor(public dialogRef: MatDialogRef<RemoveFromCartDialogComponent>) {}

  onGoBack(): void {
    this.dialogRef.close(false);
  }

  onRemove(): void {
    this.dialogRef.close(true);
  }
}
